import { render, staticRenderFns } from "./KidsProductCreate.vue?vue&type=template&id=2064b23d&scoped=true&"
import script from "./KidsProductCreate.vue?vue&type=script&lang=js&"
export * from "./KidsProductCreate.vue?vue&type=script&lang=js&"
import style0 from "./KidsProductCreate.vue?vue&type=style&index=0&id=2064b23d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064b23d",
  null
  
)

export default component.exports